import { Injectable } from '@angular/core';
import { LoginService } from 'lps-navigation';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {
  positionManager = [
    '/job_position/superintendente_on-line',
    '/job_position/superintendente',
    '/job_position/diretor_geral',
    '/job_position/diretor'
  ];

  administrator = '/user_type/administrator';

  constructor(private loginService: LoginService) { }

  getPayloadToken(): any {
    return this.loginService.getPayloadToken(this.loginService.getAuthInformation().token);
  }

  getUserType(): string {
    const payloadToken = this.getPayloadToken();

    if (payloadToken) {
      const groups: any[] = payloadToken.groups || [];

      const userType = groups.find((group: string) => group.includes('user_type'));

      return userType;
    }

    return null;
  }

  getJobPosition(): string {
    const payloadToken = this.getPayloadToken();

    if (payloadToken) {
      const groups: any[] = payloadToken.groups || [];

      const jobPosition = groups.find((group: string) => group.includes('job_position'));

      return jobPosition;
    }

    return null;
  }

  isManager(): boolean {
    const jobPosition = this.getJobPosition();
    return this.positionManager.includes(jobPosition);
  }

  isAdministrator(): boolean {
    const userType = this.getUserType();
    return this.administrator.includes(userType);
  }
}
